/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbIconModule,
  NbActionsModule,
  NbUserModule,
} from '@nebular/theme';

import { PagesModule } from './pages/pages.module';
import { ShareModule } from './shared/share.module';
import { PagesRoutingModule } from './pages/pages-routing.module';
import { CKEditorModule } from 'ngx-ckeditor';
import { HorsideRoutingModule } from './horside-routing.module';
import { Routes, RouterModule } from '@angular/router';
import { NbLoginComponent } from '@nebular/auth';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { AuthModule } from './auth/auth.module';
import { AuthGuard } from './auth/auth-guard.service';
import { AuthService } from './auth/auth.service';
import { AutoLogoutService } from './auth/auto-logout/auto-logout.service';
import { MenuItemService } from './pages/pages-menu';
const firstroutes: Routes = [

  {
    path: 'blog/bien',
    component: NbLoginComponent,
  },
]

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,NbIconModule, NbActionsModule, NbUserModule,
    RouterModule.forChild(firstroutes),
    HorsideRoutingModule,
    ShareModule,
    PagesModule,
    // FontAwesomeModule,
    PagesRoutingModule,
    
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CKEditorModule,
    AuthModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
  ],
  providers:[AuthGuard, AuthService, AutoLogoutService, MenuItemService, {provide : LocationStrategy , useClass: HashLocationStrategy}],
  entryComponents:[
  ],
  exports:[RouterModule],
  bootstrap: [AppComponent],
})
export class AppModule {
}
